export const OopsChoiceValueConstant = {
    TEXT: "TEXT",
    PERCENTAGE: "PERCENTAGE",
    TIME : "TIME",
    NUMBER: "NUMBER",
    CHOICE: "CHOICE",
    DATETIME: "DATETIME",
    DATE: "DATE"
}
